var _path, _rect, _path2, _path3, _g, _g2, _rect2, _path4, _path5, _path6, _path7, _circle, _g3, _circle2, _path8, _circle3, _path9, _circle4, _path10, _circle5, _path11, _circle6, _path12, _rect3, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLegendTooltipImage = function SvgLegendTooltipImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 92,
    fill: "none",
    viewBox: "0 0 151 92"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F5",
    d: "M30 0h113.259A3.74 3.74 0 0 1 147 3.741V86.26A3.74 3.74 0 0 1 143.259 90H30z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144.102,
    height: 89.514,
    x: 3.449,
    y: 0.449,
    stroke: "#E2E2E2",
    strokeWidth: 0.898,
    rx: 3.292
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#525869",
    d: "M3 3.741A3.74 3.74 0 0 1 6.741 0H144.26A3.74 3.74 0 0 1 148 3.741V11H3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E2E2E2",
    strokeWidth: 0.898,
    d: "M29.772 11.167v78.657"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LegendTooltipImage_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 24.497,
    r: 1.496,
    fill: "#ED4A7B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 24.497h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 31.489,
    r: 1.496,
    fill: "#FB9341"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 31.49h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 38.483,
    r: 1.496,
    fill: "#945FCF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 38.483h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 45.475,
    r: 1.496,
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 45.476h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 52.468,
    r: 1.496,
    fill: "#12A4B4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 52.468h7.482"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LegendTooltipImage_svg__b)",
    filter: "url(#LegendTooltipImage_svg__c)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 59.461,
    r: 1.496,
    fill: "#FB9341"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 59.461h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 66.454,
    r: 1.496,
    fill: "#19A979"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 66.454h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 73.447,
    r: 1.496,
    fill: "#BF399E"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 73.447h7.482"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.496,
    cy: 80.44,
    r: 1.496,
    fill: "#6C8893"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M14.986 80.44h7.482"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 97.103,
    height: 41.103,
    x: 40.449,
    y: 23.448,
    fill: "#fff",
    stroke: "#E2E2E2",
    strokeWidth: 0.897,
    rx: 3.289
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B3B9C8",
    strokeLinecap: "round",
    strokeWidth: 0.897,
    d: "M49.585 31v27H129M49.585 34.491h-1.888M49.585 41.24h-1.888M49.585 47.758h-1.888M49.585 54.275h-1.888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#945FCF",
    strokeLinecap: "round",
    d: "m53.5 53.5 22-9.214 4.5-1L92 37h12.5l14.5 6.286"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#945FCF",
    strokeLinecap: "round",
    d: "m54 52.5 12.442-8.383 13.8 2.615 15.925-5.838 6.4 3.297 16.308 2.222",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FB9341",
    strokeLinecap: "round",
    d: "m53.5 53 12.624-10.899L80.56 44.03l14.191-6.571 7.274 2.964 16.817 1.416",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 45,
    r: 2.5,
    fill: "#945FCF",
    stroke: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#LegendTooltipImage_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 34,
    x: 79,
    y: 39,
    fill: "#fff",
    rx: 3.737
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.496,
    cy: 44.496,
    r: 1.496,
    fill: "#ED4A7B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M88.986 44.497H118.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.496,
    cy: 50.489,
    r: 1.496,
    fill: "#FB9341"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M88.986 50.49H110.5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.496,
    cy: 56.483,
    r: 1.496,
    fill: "#945FCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M88.986 56.483H115"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.496,
    cy: 62.475,
    r: 1.496,
    fill: "#F4B400"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M88.986 62.476H113.5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.496,
    cy: 68.469,
    r: 1.496,
    fill: "#12A4B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE0EA",
    strokeLinecap: "round",
    strokeWidth: 0.898,
    d: "M88.986 68.468H107"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 38,
    x: 0.5,
    y: 19.5,
    stroke: "#8C95A8",
    rx: 2.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C95A8",
    d: "M16 57.5a.5.5 0 0 1 1 0zM99.5 72l2.887 5h-5.774zM17 57.5v24h-1v-24zM19.5 84h77v1h-77zM99 81.5v-5h1v5zM96.5 84a2.5 2.5 0 0 0 2.5-2.5h1a3.5 3.5 0 0 1-3.5 3.5zM17 81.5a2.5 2.5 0 0 0 2.5 2.5v1a3.5 3.5 0 0 1-3.5-3.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LegendTooltipImage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 23h15v34H9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "LegendTooltipImage_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 56h15v28H9z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "LegendTooltipImage_svg__c",
    width: 23,
    height: 36,
    x: 5,
    y: 56,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1747_8544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1747_8544",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "LegendTooltipImage_svg__d",
    width: 51,
    height: 42,
    x: 75,
    y: 35,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1747_8544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1747_8544",
    result: "shape"
  })))));
};
export default SvgLegendTooltipImage;